import { BaseLayerOptions } from './base-layer-options';
import { SelectedCircleOptions } from './selected-circle-options';

export class CircleLayerOptions extends BaseLayerOptions {
    color: any;
    radius: { base: number, stops: number[][] } | number | any;
    offset: number[];
    circleOpacity: any;
    sort: any;
    selectedColor?: any;
    strokeWidth: any;
    strokeColor: any;
    strokeOpacity: any;
    useColorFromProperties = false;
    selectedCircleOptions?: SelectedCircleOptions;

    // will automatically filter out features that are points only
    // will not work if we want to add icons along a line
    useDefaultPointFilter = false;
}
